/**
 * @generated SignedSource<<12e2afa634e7b80356efc941c00a8103>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleMoreOnThisListStyleArticle$data = {
  readonly styleMoreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent" | "entityLink">;
  } | null> | null;
  readonly " $fragmentType": "articleMoreOnThisListStyleArticle";
};
export type articleMoreOnThisListStyleArticle$key = {
  readonly " $data"?: articleMoreOnThisListStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreOnThisListStyleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleMoreOnThisListStyleArticle",
  "selections": [
    {
      "alias": "styleMoreOnThisArticles",
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contentItemRenderContent"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "af8f01c403c4e46028165a90b2844781";

export default node;
